// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3NbVo","sendOtp":"AuthorizeToLogin_sendOtp__2BzQD"};